/**
 * memberTypeDropdown.component.tsx
 * Sentriqs
 *
 * Created by: Dylan Knight
 * Copyright (c) 2024 Sentriqs, Inc. All rights reserved.
 *
**/

import React from "react";

import { ClickAwayListener, MenuItem, MenuList, Paper, Popper } from "@mui/material";

import { GroupMemberType, GroupSubmissionType } from "../models/group";

interface Props {
  anchor: HTMLElement | null | undefined,
  currentMemberType: GroupMemberType | null | undefined,
  currentSubmissionType: GroupSubmissionType | null | undefined,
  setMemberType: (memberType: GroupMemberType) => void,
  onClose: () => void
}
export function MemberTypeDropdown(props: Props): React.ReactElement<any, any> {

  const showMemberTypeMenu = Boolean(props.anchor);

  function clickAway(event: MouseEvent | TouchEvent) {
    event.stopPropagation();
    event.preventDefault();
    props.onClose();
  }
  return <Popper
    className="popup-menu"
    open={showMemberTypeMenu}
    anchorEl={props.anchor}
    modifiers={[{
      name: "preventOverflow",
      enabled: true,
      options: {
        altAxis: true,
        altBoundary: true,
        tether: true,
        rootBoundary: "document",
        padding: 8
      }
    }]}
    disablePortal={true} placement="bottom-end">
    <Paper>
      <ClickAwayListener onClickAway={clickAway}>
        <MenuList id="account-meta-menu">
          <MenuItem
            disableRipple disableTouchRipple
            selected={props.currentMemberType === GroupMemberType.owner}
            onClick={() => props.setMemberType(GroupMemberType.owner)}>
            Owner
          </MenuItem>
          <MenuItem
            disableRipple disableTouchRipple
            selected={props.currentMemberType === GroupMemberType.manager}
            onClick={() => props.setMemberType(GroupMemberType.manager)}>
            Manager
          </MenuItem>
          {props.currentSubmissionType !== GroupSubmissionType.broadcastOnly &&
            <MenuItem
              disableRipple disableTouchRipple
              selected={props.currentMemberType === GroupMemberType.user}
              onClick={() => props.setMemberType(GroupMemberType.user)}>
              User
            </MenuItem>}
          {props.currentSubmissionType !== GroupSubmissionType.dropbox &&
            <MenuItem
              disableRipple disableTouchRipple
              selected={props.currentMemberType === GroupMemberType.observer}
              onClick={() => props.setMemberType(GroupMemberType.observer)}>
              Observer
            </MenuItem>}
        </MenuList>
      </ClickAwayListener>
    </Paper>
  </Popper>;
}
